export const PageTitle = 'Триггерные сообщения';
export const TypeNames = {
    no_cart: 'Брошенная корзина',
    no_order: 'Брошенная сессия',
};
